import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const StrikethroughPrice = superstyled({
  tag: Text,
  name: 'SubscriptionPrice',
  slot: 'StrikethroughPrice',
  styles: () => ({
    textDecoration: 'line-through',
  }),
});
